import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { useMemo } from "react";
import { pluralize } from "@common/helpers/string";
import { useBulkActions } from "../useBulkActions";

interface RevertGeneralLedgerConfirmationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void>;
}

export const RevertGeneralLedgerConfirmationModal: React.FC<
    RevertGeneralLedgerConfirmationModalProps
> = ({ show, onHide, onConfirm }) => {
    const bulkActions = useBulkActions();

    const transactionsWithAccountId = useMemo(
        () =>
            bulkActions.selectedArray.filter(
                (transaction) => transaction.accountId,
            ),
        [bulkActions.selectedArray],
    );

    const selectedCount = bulkActions.selectedCount;

    const title = `Revert cash ledger for ${numberFormatter.format(selectedCount)} ${pluralize("transaction", selectedCount)}`;

    const haveOrHas = transactionsWithAccountId.length > 1 ? "have" : "has";
    const themOrIt = transactionsWithAccountId.length > 1 ? "them" : "it";

    const question =
        transactionsWithAccountId.length === selectedCount
            ? `Are you sure you want to revert the cash ledger assignment for all selected ${pluralize("transaction", selectedCount)}?`
            : `${numberFormatter.format(transactionsWithAccountId.length)} of ${numberFormatter.format(selectedCount)} selected ${pluralize("transaction", selectedCount)} ${haveOrHas} cash ledger assignments. Do you want to revert ${themOrIt}?`;

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirm={onConfirm}
            title={title}
            question={question}
            yes="Revert"
            yesBtnVariant="primary"
        />
    );
};
